import {
  ActionButton,
  CalendarHeader,
  Paginator,
  SearchSelectInput,
  TableComponent,
  Tabs,
} from "components";
import { useAppNavigate, useAppSearch } from "_graphql/cache/auth";

import { OfferStatus } from "_graphql/__generated__/globalTypes-kek";
import _ from "lodash";
import { useBankingTray } from "hooks/data/use-banking-tray";
import { usePagination } from "hooks";
import { useUrlState } from "utils";

type Props = {};

const tabColumns = {
  "1": [
    {
      name: "Date of Receipt",
      accessor: "date_of_receipt",
      render: (data: any) => <>{data.date_of_receipt || "N/A"}</>,
    },
    {
      name: "Cheque Number",
      accessor: "cheque_number",
    },
    {
      name: "Cheque Amount",
      accessor: "amount",
    },
    {
      name: "Cedant",
      accessor: "reinsured",
    },
  ],
  "2": [
    {
      name: "Date of Deposit",
      accessor: "date_of_deposit",
      render: (data: any) => <>{data.date_of_deposit || "N/A"}</>,
    },
    {
      name: "Payment Details",
      accessor: "cheque_number",
    },
    {
      name: "Amount",
      accessor: "amount",
    },
    {
      name: "Reinsured",
      accessor: "reinsured",
    },
  ],
  "3": [
    {
      name: "Date Of Clearance",
      accessor: "date_cheque_cleared",
      render: (data: any) => <>{data.date_cheque_cleared || "N/A"}</>,
    },
    {
      name: "Payment Details",
      accessor: "cheque_number",
    },
    {
      name: "Amount",
      accessor: "amount",
    },
    {
      name: "Reinsured",
      accessor: "reinsured",
    },
  ],
};

const BankingTrayPage = (props: Props) => {
  const [orderStatus] = useUrlState("orderStatus");
  const navigate = useAppNavigate();
  const searchParams = useAppSearch();
  const { offset, limit, setPage, search, fromDate, toDate } = usePagination();
  const { items, loading, refetch, count } = useBankingTray({
    filter: {
      tab_number: !orderStatus ? 1 : Number(orderStatus),
      search: search || undefined,
      status: (searchParams.offer_status as OfferStatus) || undefined,
      dateFrom: fromDate || undefined,
      dateTo: toDate || undefined,
    },
    pagination: {
      offset,
      limit,
    },
  });

  const expandItem = (id: string) => () => {
    navigate({
      to: `./${id}/view`,
    });
  };

  return (
    <main className="flex-1 flex flex-col overflow-hidden bg-background-500">
      <CalendarHeader />
      <Tabs
        tabs={[
          { href: "2", name: "Deposited To Bank" },
          { href: "3", name: "Payment Cleared" },
        ]}
        defaultTab="Payment Received"
        orderStatus={orderStatus?.toString()}
      />
      <div className="flex flex-1 overflow-y-auto">
        <div className="flex-1 mx-auto min-w-0  py-4 sm:py-6 overflow-hidden overflow-y-auto light flex">
          <TableComponent
            title={"Banking Tray"}
            renderActions={() => (
              <SearchSelectInput
                id={"claim_status"}
                label={""}
                labelHidden
                placeholder="Filter by status"
                options={[
                  {
                    label: {
                      title: "Open",
                    },
                    value: "OPEN",
                  },
                  {
                    label: {
                      title: "Pending",
                    },
                    value: "PENDING",
                  },
                  {
                    label: {
                      title: "Closed",
                    },
                    value: "CLOSED",
                  },
                ]}
                values={{ status: searchParams.offer_status }}
                setFieldValue={(key: any, value: any) => {
                  // console.log(value);
                  navigate({
                    search(old) {
                      return {
                        ...old,
                        page: 1,
                        offer_status: value || undefined,
                      };
                    },
                  });
                }}
                className="w-64"
              />
            )}
            columns={[
              ..._.get(
                tabColumns,
                !orderStatus ? "1" : orderStatus.toString(),
                tabColumns["1"]
              ),
              {
                name: "Actions",
                accessor: "actions",
                render: (data) => (
                  <>
                    <ActionButton
                      action="expand"
                      tooltip="View Breakdown"
                      onClick={expandItem(data.offers?.join("-") as string)}
                    />
                  </>
                ),
              },
            ]}
            loading={loading}
            data={items}
            refetch={refetch}
            hasSearch
            pagination={() => (
              <Paginator
                offset={offset}
                limit={limit}
                totalItems={count}
                currentSize={items.length}
                setOffset={setPage}
              />
            )}
          />
        </div>
      </div>
    </main>
  );
};

export default BankingTrayPage;
